import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=271575cf&scoped=true"
import script from "./productDetail.js?vue&type=script&lang=js&external"
export * from "./productDetail.js?vue&type=script&lang=js&external"
import style0 from "./productDetail.scss?vue&type=style&index=0&id=271575cf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271575cf",
  null
  
)

export default component.exports